<template>
  <div :class="$style.topbar">
    <div class="mr-auto">
      <cui-live-search/>
    </div>
    <div class="mr-4">
      <cui-notification-menu/>
    </div>
    <cui-profile-menu/>
  </div>
</template>

<script>
import CuiLiveSearch from '@/components/LayoutComponents/Topbar/LiveSearch'
import CuiNotificationMenu from '@/components/LayoutComponents/Topbar/NotificationMenu'
import CuiProfileMenu from '@/components/LayoutComponents/Topbar/ProfileMenu'

export default {
  components: {
    CuiLiveSearch,
    CuiNotificationMenu,
    CuiProfileMenu,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
